var AdUnitLazyLoader;

AdUnitLazyLoader = window.AdUnitLazyLoader = {
  load: function() {
    return $('.ad-widget iframe').attr('src', function() {
      return $(this).attr('data-src');
    });
  }
};

module.exports = AdUnitLazyLoader;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9hZF91bml0L2Zyb250ZW5kL2FkX3VuaXRfbGF6eV9sb2FkZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9hZF91bml0L2Zyb250ZW5kL2FkX3VuaXRfbGF6eV9sb2FkZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsZ0JBQUEsR0FBbUIsTUFBTSxDQUFDLGdCQUFQLEdBQ2pCO0VBQUEsSUFBQSxFQUFNLFNBQUE7V0FDSixDQUFBLENBQUUsbUJBQUYsQ0FBc0IsQ0FBQyxJQUF2QixDQUE0QixLQUE1QixFQUFtQyxTQUFBO2FBQ2pDLENBQUEsQ0FBRSxJQUFGLENBQU8sQ0FBQyxJQUFSLENBQWEsVUFBYjtJQURpQyxDQUFuQztFQURJLENBQU47OztBQUtGLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
